import { useCallback, useState } from "react"
import { ActivityCard } from "../ActivityCard"
import { SparkCard } from "../SparkCard"
import { ExpandProvider, useExpandedId, useCollapseAll } from "../../../hooks/useExpanded"
import Meetings from "../Meetings"
import useIsMobile from "../../../hooks/isMobile"

export default function ChapterPreview({chapter, enrollmentId, matchType, onItemCompleted}) {
    return (
        <ExpandProvider>
            <ChapterPreviewContent chapter={chapter} enrollmentId={enrollmentId} matchType={matchType} onItemCompleted={onItemCompleted}/>
        </ExpandProvider>
    )
}

function ChapterPreviewContent({chapter, enrollmentId, onItemCompleted, matchType}) {

    const isTablet = useIsMobile(1350)
    const expandedId = useExpandedId()
    const collapseAll = useCollapseAll()
    const [meetingsActive, setMeetingsActive] = useState(false)

    const handleMeetingsActiveChange = useCallback((active) => {
        if (active) collapseAll()
        setMeetingsActive(active)
    }, [collapseAll])

    const activitiesExpanded = chapter?.activities?.some(a => a.id === expandedId)
    const sparksExpanded = chapter?.sparks?.some(s => s.id === expandedId)
    const focusedColumn = activitiesExpanded ? 'activities' : sparksExpanded ? 'sparks' : meetingsActive ? 'meetings' : null

    const colWidth = (col) => !focusedColumn ? '1fr' : focusedColumn === col ? '2fr' : '1fr'

    const handleActivityCompleted = (activity) => {
        onItemCompleted(activity.id)
    }

    const handleSparkCompleted = (spark) => {
        onItemCompleted(spark.id)
    }

    return(<div>
        {chapter && <div className="grid gap-xl showing" style={{
            gridTemplateColumns: isTablet ? '1fr' : `${colWidth('activities')} ${colWidth('sparks')} ${colWidth('meetings')}`,
            transition: 'grid-template-columns 0.15s ease-in-out'
        }}>
            <div className="flex columns gap-xs">
                <p className="section-title-s accent bold text-center vi-spacer-s" style={{marginBottom: isTablet ? 'var(--xs)' : '42px'}}>Activities</p>
                <div className="shaded-primary radius padding-s flex columns justify-center" style={{minHeight: '116px'}}>
                    <p className="card-label neutral text-center">The activities below are suggestions only and designed to stand-alone, so you can pick either or both and adapt them to your goals.</p>
                </div>
                {chapter?.activities?.map(activity => <ActivityCard activity={activity} key={activity?.id} onComplete={handleActivityCompleted}/>)}
            </div>
            <div className="flex columns gap-xs" style={{marginTop: isTablet ? 'var(--l)' : '0'}}>
                <p className="section-title-s accent bold text-center vi-spacer-s" style={{marginBottom: isTablet ? 'var(--xs)' : '42px'}}>Sparks</p>
                <div className="shaded-primary radius padding-s flex columns justify-center" style={{minHeight: '116px'}}>
                    <p className="card-label neutral text-center">Listen to the short audio coaching clips below before or between sessions to get the most out of your time together.</p>
                </div>
                {chapter?.sparks?.map(spark => <SparkCard spark={spark} key={spark?.id} onComplete={handleSparkCompleted}/>)}
            </div>
            <div className="flex columns gap-xs" style={{marginTop: isTablet ? 'var(--l)' : '0'}}>
                <Meetings chapterId={chapter?.id ?? ''} enrollmentId={enrollmentId} onActiveChange={handleMeetingsActiveChange}/>
            </div>
        </div>}
        {!chapter && <div className="dashed-card columns standard-padding showing">
            <p className="card-title">No Unlocked Chapters</p>
            <p className="card-body">{matchType == 'Mentee' ? 'Select one of the previous chapters on the left or unlock the next chapter.' : 'Select one of the previous chapters on the left or contact your mentor about upcoming chapters.'}</p>
        </div>}
    </div>)
}